import { TypedDocumentNode, gql } from "@apollo/client";
import { Graph_QL } from "../";

// const ServerValues = gql`
//   fragment NameParts on Person {
//     firstName
//     lastName
//   }
// `

// # GetLive
export interface GetLiveStateArgs {
  domain:string, gate:number, device:number
  //humanTime?:boolean
}
export interface LiveStateItem {
  state:boolean, __typename?:string,
  value1:number, value2:number, value3:number,
  value4:number, value5:number, value6:number
}
export interface LiveStateResponse {
  getOnlineState:LiveStateItem
}
// export const GET_LIVE_STATES = (connection:ConnectionObj[]):TypedDocumentNode<LiveStateResponse, undefined> => {
//   return gql`query GetOnlineState {
//     ${connection.map(({ domain, gate, device }, index) => `
//       getOnlineState_${index}:getOnlineState(domain: "${domain}", gatewayindex: ${gate}, mapdeviceindex: ${device}) {
//         state
//         value1 value2 value3
//         value4 value5 value6
//       }
//     `)}
//   }`
// }
export const GET_LIVE_STATE: TypedDocumentNode<LiveStateResponse, GetLiveStateArgs> = gql`
  query GetOnlineState($domain: String!, $gate: Int!, $device: Int!) {
    getOnlineState(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device) {
      state
      value1 value2 value3
      value4 value5 value6
    }
  }
`;

// # GetStartConfigs
export interface GetStartConfigsArgs {
  domain:string, gatewayindex:number, mapdeviceindex:number
}
export interface StartConfigs {
  value:string
}
export interface StartConfigsResponse {
  getStartConfigs:StartConfigs[]
}
export const GetStartConfigs = gql`
 query GetStartConfigs($gatewayindex: Int!, $mapdeviceindex: Int!, $domain: String) {
  getStartConfigs(gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, domain: $domain) {
    value
  }
}
`;

//Device calls
export interface LogItem {
  id:number, gatewayindex:number, mapdeviceindex:number,
  timestamp:Date|number, message:string,
  __typename?:string
}
export interface LogsResponse {
  getLog:LogItem[]
}
export interface GetLogsArgs {
  domain:string, gate?:number, device?:number
  humanTime?:boolean, lastid?:number, fetch?:boolean
}
export const GET_LOGS = gql`
  query GetLog($domain: String!, $gate: Int, $device: Int, $humanTime: Boolean, $lastid: Int, $fetch: Boolean) {
    getLog(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device, HumanTime: $humanTime, lastid: $lastid, fetch: $fetch) {
      id gatewayindex mapdeviceindex
      timestamp message
    }
  }
`;

export interface TableFromDeviceItem {
  id: number,
  gatewayindex:number,
  mapdeviceindex:number,
  maptableindex: number,
  timestamp: Date|number,
  datasetflags: number,
  rowindex: number,
  colindex: number,
  colvalue: string|number,
  __typename?:string
}

export interface TableFromDeviceResponse {
  getTableFromDevice: TableFromDeviceItem[]
}

export interface GetTableFromDeviceArgs {
  domain:string, gate?:number, device?:number
  table?:number, fetch?:boolean
}

export const GET_TABLE_FROM_DEVICE = gql`
    query GetTableFromDevice($domain: String!, $gatewayindex: Int!, $mapdeviceindex: Int!, $maptableindex: Int!) {
  getTableFromDevice(domain: $domain, gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, maptableindex: $maptableindex) {
    id
    rowindex
    colindex
    maptableindex
    colvalue
    timestamp
    datasetflags
  }
}
`;

export interface AvailableBinsItem {

}

export interface AvailableBinsResponse {
  getAvailableBins: AvailableBinsItem[]
}

export interface GetAvailableBinsArgs {
  version: string
}

export const GET_AVAILABLE_BINS = gql`    
  query GetAvailableBins($version: String) {
    getAvailableBins(version: $version)
  }
`;
export interface GetGlobalSettingsItem {
  id: string;
  rowindex: number;
  colindex: number;
  colvalue: string;
}

export interface GetGlobalSettingsResponse {
  getGlobalSettings: GetGlobalSettingsItem[]
}

export interface GetGlobalSettingsArgs {
  version: string
}

export const GET_GETGLOBALSETTINGS = gql`    
query GetGlobalSettings($mapdeviceindex: Int!, $domain: String, $gatewayindex: Int!) {
  getGlobalSettings(mapdeviceindex: $mapdeviceindex, domain: $domain, gatewayindex: $gatewayindex) {
    id
    rowindex
    colindex
    colvalue
  }
}
`;

export interface AvailableVmsItem {

}

export interface AvailableVmsResponse {
  getAvailableVms: AvailableVmsItem[]
}

export interface GetAvailableVmsArgs {
  version: string
}

export const GET_AVAILABLE_VMS = gql`    
  query GetAvailableVms($version: String) {
    getAvailableVms(version: $version)
  }
`;

export interface DailyScaleItem {
  gatewayindex?:number,
  mapdeviceindex?:number,
  timestamp:Date|number,
  value1:number,
  value2:number,
  value3:number,
  value4:number,
  __typename?:string
}
export interface DailyScaleResponse {
  getDailyScales:DailyScaleItem[]
}
export interface GetDailyScaleArgs {
  domain:string,
  gate:number,
  device:number,
  humanTime?:boolean,
  lastDays?:number
}
export const GET_DAILYSCALES = gql`
  query GetDailyScales($domain: String!, $gate: Int, $device: Int, $lastDays: Int, $limitDays: Int, $humanTime: Boolean) {
    getDailyScales(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device, lastDays: $lastDays, limitDays: $limitDays, HumanTime: $humanTime) {
      gatewayindex mapdeviceindex
      value1 value2 value3 value4
      timestamp
    }
  }
`;

export interface DailyTempItem {
  gatewayindex?:number,
  mapdeviceindex?:number,
  timestamp:Date|number,
  value1:number,
  value2:number,
  value3:number,
  value4:number,
  __typename?:string
}
export interface DailyTempResponse {
  getDailyTemperature:DailyTempItem[]
}
export interface GetDailyTempArgs {
  domain:string,
  gate:number,
  device:number,
  humanTime?:boolean,
  lastDays?:number
}
export const GET_DAILYTEMPERATURES = gql`
  query GetDailyTemperature($domain: String!, $gate: Int, $device: Int, $lastDays: Int, $limitDays: Int, $humanTime: Boolean) {
    getDailyTemperature(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device, lastDays: $lastDays, limitDays: $limitDays, HumanTime: $humanTime) {
      gatewayindex mapdeviceindex
      value1 value2 value3 value4
      timestamp
    }
  }
`;

export interface DailyWaterItem {
  gatewayindex?:number,
  mapdeviceindex?:number,
  timestamp:Date|number,
  value1:number,
  value2:number,
  value3:number,
  value4:number,
  __typename?:string
}
export interface DailyWaterResponse {
  getDailyWater:DailyWaterItem[]
}
export interface GetDailyWaterArgs {
  domain:string,
  gate:number,
  device:number,
  humanTime?:boolean,
  lastDays?:number
}
export const GET_DAILYWATERS = gql`
  query GetDailyWater($domain: String!, $gate: Int, $device: Int, $lastDays: Int, $limitDays: Int, $humanTime: Boolean) {
    getDailyWater(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device, lastDays: $lastDays, limitDays: $limitDays, HumanTime: $humanTime) {
      gatewayindex mapdeviceindex
      value1 value2 value3 value4
      timestamp
    }
  }
`;
export interface AllRfidItem {
  id: string,
  value:number,
}
export interface AllRfidResponse {
  getRfids:AllRfidItem[]
}
export interface GetAllRfidArgs {
  domain:string,
  gate:number,
  device:number,
  lastDays?:number,
  limitDays?: number
}
export const GET_ALLRFIDS = gql`
    query GetRfids($domain: String!, $gate: Int!, $device: Int!, $lastDays: Int, $limitDays: Int) {
  getRfids(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device, lastDays: $lastDays, limitDays: $limitDays) {
    id
    value
  }
}
`;
export interface DailyScalesByRFIDItem {
  gatewayindex?:number,
  mapdeviceindex?:number,
  timestamp:Date|number,
  value1:number,
  value2:number,
  value3:number,
  value4:number,
  value5:number,
  value6:string,
  
  
}
export interface DailyScalesByRFIDResponse {
  getDailyScalesByRFID:DailyScalesByRFIDItem[]
  
}

export interface GetDailyScalesByRFIDArgs {
  domain:string,
  gate:number,
  device:number,
  lastDays?:number | null,
  limitDays?: number | null,
  rfid: string
}
export const GET_DAILYSCALESBYRFID = gql`
    query GetDailyScalesByRFID($domain: String!, $gate: Int, $device: Int, $lastDays: Int, $limitDays: Int, $rfid: String) {
  getDailyScalesByRFID(domain: $domain, gatewayindex: $gate, mapdeviceindex: $device, lastDays: $lastDays, limitDays: $limitDays, RFID: $rfid) {
   gatewayindex
    mapdeviceindex
    timestamp
    value1
    value2
    value3
    value4
    value5
    value6
  }
}
`;  

export interface ChangeFirmwareItem {
  code:string,
  message:string,
  success:boolean
}
export interface ChangeFirmwareResponse {
  changeFirmware:ChangeFirmwareItem;
}
export interface GetChangeFirmwareArgs {
  domain:string,
  gate:number,
  device:number,
  firmwarenumber:number
}
export const GET_CHANGEFIRMWARE = gql`
mutation ChangeFirmware($domain: String!, $gatewayindex: Int!, $mapdeviceindex: Int!, $firmwarenumber: Int!) {
  changeFirmware(domain: $domain, gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, firmwarenumber: $firmwarenumber) {
    code
    message
    success
  }
}
`;
export interface ChangeVmSoftwareItem {
  code:string,
  message:string,
  success:boolean
}
export interface ChangeVmSoftwareResponse {
  changeVmSoftware:ChangeVmSoftwareItem | null
}
export interface GetChangeVmSoftwareArgs {
 domain:string,
  gate:number,
  device:number,
  filename:string
}
export const GET_CHANGEVMSOFTWARE = gql`
mutation ChangeVmSoftware($domain: String!, $mapdeviceindex: Int!, $filename: String!, $gatewayindex: Int!) {
  changeVmSoftware(domain: $domain, mapdeviceindex: $mapdeviceindex, filename: $filename, gatewayindex: $gatewayindex) {
    code
    success
    message
  }
}
`;

export type Plc_Dataset = 
{
  id?:             number,
  rowindex?:       number,
  colindex?:       number,
  maptableindex?:  number,
  colvalue?:       string | number,
  timestamp?:      number,
  datasetflags?:   number,
}
export interface ChangeGlobalSettingsItem {
  code:string,
  message:string,
  success:boolean
}
export interface ChangeGlobalSettingsResponse {
  setGlobalSettings:ChangeGlobalSettingsItem;
}
export interface GetChangeGlobalSettingsArgs {
  domain:string,
  gate:number,
  device:number,
  value:Plc_Dataset[],
}

export const GET_CHANGEGLOBALSETTINGS = gql`
mutation SetGlobalSettings($domain: String!, $gatewayindex: Int!, $mapdeviceindex: Int!, $value: [PlcDataset!]!, $fullTable: Boolean) {
  setGlobalSettings(domain: $domain, gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, value: $value, FullTable: $fullTable) {
    code
    success
    message
  }
}
`;
export interface WeightLimits {
  CurveNo:   number,
  Name:      string,
  Weight:    number,
  MinWeight: number,
  MaxWeight: number,
  ScaleTime: number,
  Reset:     number,
}

export interface SetWeightLimitsItem {
  code: string,
  message: string,
  success: boolean
}
export interface SetWeightLimitsResponse {
  setWeightLimits:SetWeightLimitsItem
}
export interface GetSetWeightLimitsArgs {
  domain:string,
  gate:number,
  device:number,
  value:WeightLimits[],
  fullTable: boolean,
}
export const GET_SETWEIGHTLIMITS = gql`
mutation SetWeightLimits($domain: String!, $gatewayindex: Int!, $mapdeviceindex: Int!, $value: [WeightLimits!]!, $fullTable: Boolean) {
  setWeightLimits(domain: $domain, gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, value: $value, FullTable: $fullTable) {
    code
    success
    message
  }
}
`;

export interface ResetScaleItem {
  code: string,
  message: string,
  success: boolean
}
export interface ResetScaleResponse {
  resetScale:ResetScaleItem[]
}
export interface GetResetScaleArgs {
  domain:string,
  gate:number,
  device:number,
  value: number,
}
export const GET_RESETSCALE = gql`
mutation SetInternal($domain: String!, $gatewayindex: Int!, $mapdeviceindex: Int!, $value: Int!) {
  setInternal(domain: $domain, gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, value: $value) {
    code
    success
    message
  }
}
`;
export interface TaraScaleItem {
  code: string,
  message: string,
  success: boolean
}
export interface TaraScaleResponse {
  taraScale:TaraScaleItem[]
}
export interface GetTaraScaleArgs {
  domain:string,
  gate:number,
  device:number,
}
export const GET_TARASCALE = gql`
query DoTara($mapdeviceindex: Int!, $domain: String, $gatewayindex: Int!) {
  doTara(mapdeviceindex: $mapdeviceindex, domain: $domain, gatewayindex: $gatewayindex) {
    code
    success
    message
  }
}
`;
export interface CalibrateScaleItem {
  code: string,
  message: string,
  success: boolean
}
export interface CalibrateScaleResponse {
  calibrateScale: CalibrateScaleItem[]
}
export interface GetCalibrateScaleArgs {
  domain:string,
  gate:number,
  device:number,
  value: number,
}
export const GET_CALIBRATESCALE = gql`
query DoCalibration($domain: String!, $gatewayindex: Int!, $mapdeviceindex: Int!, $value: Int!) {
  doCalibration(domain: $domain, gatewayindex: $gatewayindex, mapdeviceindex: $mapdeviceindex, value: $value) {
    code
    success
    message
  }
}
`;
export interface ChangeMdiItem {
  code: string,
  message: string,
  success: boolean
}
export interface ChangeMdiResponse {
  changeMdi: ChangeMdiItem
}
export interface GetChangeMdiArgs {
  domain:string,
  gate:number,
  oldmapdeviceindex:number,
  newmapdeviceindex:number,
  macadress:string,
}
export const GET_CHANGEMDI = gql`
mutation ChangeMdi($domain: String!, $gatewayindex: Int!, $oldmapdeviceindex: Int!, $newmapdeviceindex: Int!, $macadress: String!) {
  changeMdi(domain: $domain, gatewayindex: $gatewayindex, oldmapdeviceindex: $oldmapdeviceindex, newmapdeviceindex: $newmapdeviceindex, macadress: $macadress) {
    code
    success
    message
  }
}
`;
export interface ChangeGateItem {
  code: string,
  message: string,
  success: boolean
}
export interface ChangeGateResponse {
  changeGate: ChangeGateItem
}
export interface GetChangeGateArgs {
  domain:string,
  oldgateindex:number,
  newgateindex:number,
  macadress:string,
}
export const GET_CHANGEGATE = gql`
mutation ChangeGate($domain: String!, $newgatewayindex: Int!, $macadress: String!, $oldgatewayindex: Int!) {
  changeGate(domain: $domain, newgatewayindex: $newgatewayindex, macadress: $macadress, oldgatewayindex: $oldgatewayindex) {
    code
    success
    message
  }
}
`;
export interface ChangeDomainItem {
  code: string,
  message: string,
  success: boolean
}
export interface ChangeDomainResponse {
  changeDomain: ChangeDomainItem
}
export interface GetChangeDomainArgs {
  domain:string,
  gatewayindex:number,
  newdomain:string,
  newpin:number,
  macadress:string,
}
export const GET_CHANGEDOMAIN = gql`
mutation ChangeDomain($domain: String!, $newdomain: String!, $newpin: Int!, $macadress: String!, $gatewayindex: Int!) {
  changeDomain(domain: $domain, newdomain: $newdomain, newpin: $newpin, macadress: $macadress, gatewayindex: $gatewayindex) {
    code
    success
    message
  }
}
`;
export interface ChangeIpItem {
  code: string,
  message: string,
  success: boolean
}
export interface ChangeIpResponse {
  changeIp: ChangeIpItem
}
export interface GetChangeIpArgs {
  domain:string,
  gatewayindex:number,
  newdomain:string,
  newpin:number,
  macadress:string,
}
export const GET_CHANGEIP = gql`
mutation ChangeIp($domain: String!, $newdomain: String!, $newpin: Int!, $macadress: String!, $gatewayindex: Int!) {
  changeIp(domain: $domain, newdomain: $newdomain, newpin: $newpin, macadress: $macadress, gatewayindex: $gatewayindex) {
    code
    success
    message
  }
}
`;


//end

